import { render, staticRenderFns } from "./directSales.vue?vue&type=template&id=8a72c87e&scoped=true"
import script from "./directSales.vue?vue&type=script&lang=js"
export * from "./directSales.vue?vue&type=script&lang=js"
import style0 from "./directSales.vue?vue&type=style&index=0&id=8a72c87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a72c87e",
  null
  
)

export default component.exports